import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as EyeOff } from "src/assets/static/images/eye-off.svg";
import { ReactComponent as EyeOn } from "src/assets/static/images/eye.svg";
import useFormatById from "src/hooks/utils/useFormatById";
import actions from "src/store/auth/actions";

const AuthorizationPassword = ({
  pId,
  setPId,
  password,
  setPassword,
  loginError,
  setIsPasswordRecover,
}) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const formatMessage = useFormatById();
  const dispatch = useDispatch();
  const updateCounter = useSelector((state) => state.profileMain.updateCounter);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  const [rememberMe, setRememberMe] = useState(false);
  const handleLogin = (e) => {
    e.preventDefault();
    dispatch(actions.loginRequest(pId?.trim(), password, rememberMe));
    const timeout = setTimeout(window.refreshWidgetVisibility(), 500);
    return () => {
      clearTimeout(timeout);
    };
  };

  useEffect(() => {
    const usr = localStorage.getItem("usr");
    const pwd = localStorage.getItem("pwd");

    if (usr && (pwd || pwd === "") && (pId === "" || pId === usr)) {
      setPId(usr);
      setPassword(atob(pwd));
      setRememberMe(true);
    }
  }, [updateCounter]);

  const loading = useSelector((state) => state.auth.loading);

  return (
    <form onSubmit={handleLogin}>
      <div>
        <div className="form-floating pb-1">
          <input
            type={passwordVisible ? "text" : "password"}
            className={
              "form-control loginInput" +
              (loginError === "406" ? " error-input-style" : "")
            }
            id="floatingPassword"
            value={password}
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="off"
          />
          <label htmlFor="floatingPassword" style={{ color: "#424244" }}>
            {formatMessage("login.Password")}
          </label>
        </div>
        {passwordVisible === true ? (
          <EyeOn
            className="toggle-eye-style"
            onClick={togglePasswordVisibility}
          />
        ) : (
          <EyeOff
            className="toggle-eye-style"
            onClick={togglePasswordVisibility}
          />
        )}
        {loginError === "406" && (
          <span className="error-text-style ms-2">
            {formatMessage("login.PasswordIsIncorrect")}
          </span>
        )}
      </div>
      <div className="row m-sm-2 mt-sm-2 mt-2">
        <div className="col-6">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={rememberMe}
              onChange={() => setRememberMe(!rememberMe)}
              id="flexCheckDefault"
            />
            <label
              className="form-check-label"
              htmlFor="flexCheckDefault"
              style={{ color: "#424244" }}
            >
              {formatMessage("login.RememberMe")}
            </label>
          </div>
        </div>
        <div className="col-6 mt-1 text-center">
          <div
            className="forgot-password"
            onClick={() => setIsPasswordRecover(true)}
          >
            {formatMessage("login.ForgotPassword")}
          </div>
        </div>
      </div>
      <div className="text-center pt-4">
        <button
          className="btn btn-primary login-button"
          disabled={loading || password === "" || pId === ""}
          // onClick={() => handleLogin()}
        >
          {loading ? (
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            formatMessage("login.Login")
          )}
        </button>
      </div>
    </form>
  );
};

export default AuthorizationPassword;
